import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class SendTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Envelope icon position (top-left corner)
    const ix = x - width / 2 + 8;
    const iy = y - height / 2 + 6;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Send icon (filled envelope)
      h('path', {
        d: `M ${ix} ${iy + 2} L ${ix + 6} ${iy + 7} L ${ix + 12} ${iy + 2} L ${ix + 12} ${iy + 12} L ${ix} ${iy + 12} Z`,
        fill: style.stroke,
        stroke: style.stroke,
        strokeWidth: 1,
      }),
      h('path', {
        d: `M ${ix} ${iy + 2} L ${ix + 6} ${iy + 7} L ${ix + 12} ${iy + 2}`,
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 1,
      }),
    ];

    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class SendTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'sendTask');
    style.stroke = t.stroke || '#1d39c4';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#f0f5ff';
    return style;
  }
}

export const SendTask = {
  type: 'epx:SendTask',
  view: SendTaskView,
  model: SendTaskModel,
};
